import { graphql } from '@api/generated';

export const autocompleteAddressQuery = graphql(`
  query autocompleteAddress($input: String!, $sessionToken: String!) {
    autocompleteAddress(input: $input, sessionToken: $sessionToken) {
      suggestions {
        placeId
        text
      }
    }
  }
`);

export const addressDetailsQuery = graphql(`
  query addressDetails($placeId: String!, $sessionToken: String!) {
    addressDetails(placeId: $placeId, sessionToken: $sessionToken) {
      street
      unit
      city
      state
      country
      zip
      latitude
      longitude
    }
  }
`);
